import { render } from "./AdminHotels.vue?vue&type=template&id=c22fd246"
import script from "./AdminHotels.vue?vue&type=script&lang=js"
export * from "./AdminHotels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__